import { useEffect } from "react";
import { useParams } from "react-router";
import SeoLocalization from "../../localization/SeoLocalization";

function SEO() {
    const { lang } = useParams();
    const selectedLanguage = SeoLocalization[lang] ? lang : "en";
    const { title, description } = SeoLocalization[selectedLanguage];

    useEffect(() => {
        document.title = title;
        document.querySelector('meta[name="description"]').setAttribute("content", description);
    }, [title, description]);

    return null;
}

export default SEO;
